/**
 * Inline Message
 * Inline <P> style message with coloring and icons
 */
import type { IconName } from '@fortawesome/fontawesome-common-types';
import { useTheme } from '@mui/material/styles';
import React from 'react';

import Icon from '@components/Icon/Icon';

import { MessageContainer, TextDiv, Text } from './InlineMessage.style';

type MessageVariant = 'error' | 'info' | 'success' | 'warning';

export const InlineMessage: React.FC<{
  type?: MessageVariant;
  message?: string;
  padding?: string;
}> = ({ type = 'error', message = '', padding }) => {
  const { palette } = useTheme();
  let color: string;
  let iconName: IconName;
  switch (type) {
    case 'error':
      color = palette.error.main;
      iconName = 'circle-xmark';
      break;
    case 'info':
      color = palette.info.main;
      iconName = 'circle-info';
      break;

    case 'success':
      color = palette.success.main;
      iconName = 'circle-check';
      break;

    case 'warning':
      color = palette.warning.main;
      iconName = 'triangle-exclamation';
      break;
  }

  return (
    <MessageContainer color={color} data-testid="message-container">
      <Icon color={color} name={iconName} type="fad" />
      <TextDiv>
        <Text padding={padding}>{message}</Text>
      </TextDiv>
    </MessageContainer>
  );
};
